import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcce76fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FeaturedBanner" }
const _hoisted_2 = { class: "FeaturedBanner-top" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "FeaturedBanner-link"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "marking-content"
}
const _hoisted_8 = { style: {"display":"flex"} }

import { ref, onMounted, reactive, computed } from 'vue'
import { getPurePlatformList, getPlatDetail } from '@/apis/platform'
import { useRequest } from '@/util/useLoading'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { bury } from '@/util/useBury'
import { isJA, useRtfix } from '@/store'

interface promotionItem {
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()
const store = useStore()
const csl = ref()

onMounted(() => {
  // setTimeout(() => {
  //   csl.value.setActiveItem(0)
  // }, 500)
  getPlatList()
})



const data: any = reactive({
  // banner列表
  bannerList: [],
  // 活动列表
  promotionList: []
})

// 获取平台列表
const [loading, getPlatList] = useRequest(() => {
  return getPurePlatformList({}).then((res: any) => {
    if (res.code === '0') {
      for (const item of res.data[0].onlineManageList) {
        if (getNameByType() === item.platformName) {
          const onlineManageId = item.onlineManageId
          getPlatDetail({ onlineManageId }).then((res: any) => {
            if (res.code === '0') {
              if (res.data.bannerList.length !== 0) {
                data.bannerList = res.data.bannerList
                data.promotionList = res.data.promotionList
              } else {
                data.bannerList.push({
                  bannerUrl: require('@/assets/image/banner-default.png'),
                  jumpUrl: '#',
                  onlineManageBannerId: '-1'
                })
              }
            }
          })
        }
      }
    }
  })
})

// 匹配当前平台名
const getNameByType = () => {
  if (route.params.type === 'taobao') {
    return '淘宝'
  } else
  if (route.params.type === 'tmall') {
    return '天猫'
  } else
  if (route.params.type === '1688') {
    return '1688'
  }
}

const buss = reactive(store.state.bussiness)
const langType = computed(() => store.state.bussiness.langType)

// 跳转外链
const handleJump = (item: promotionItem, index = -1) => {
  if (index === 0 && route.params.type === '1688') {
    store.commit('bussiness/platformType', 'AM')
    const keyword = route.query.keyword || isJA() ? (langType.value === 2 ? '1688国家货盘' : t('1688国家货盘')) : (langType.value === 2 ? '1688严选' : t('1688严选'))
    buss.keyword = keyword
    const query: any = {
      schannel: 2,
      platformType: 'AM',
      keyword: keyword
    }
    router[route.name?.toString().includes('list') ? 'replace' : 'push'](
      useRtfix('list', { query })
    )
  } else {
    window.open(item.url)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(data).bannerList.length !== 0)
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 0,
            ref: (_value, _refs) => {
              _refs['csl'] = _value
              csl.value = _value
            },
            height: "386px",
            "indicator-position": "none"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).bannerList, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: item.onlineManageBannerId
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      referrerPolicy: "no-referrer",
                      class: "wrap hover",
                      src: item.bannerUrl,
                      onClick: ($event: any) => (handleJump(item))
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).getters.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).promotionList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.onlineManagePromotionId,
              class: "FeaturedBanner-link-item hover",
              onClick: ($event: any) => (handleJump(item, index))
            }, [
              _createElementVNode("img", {
                referrerPolicy: "no-referrer",
                class: "wrap",
                src: item.promotionUrl
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: _normalizeClass(`FeaturedBanner-link-item-text ${index === 0 && _unref(route).params.type === '1688' ? 'active1688' : ''}`)
              }, _toDisplayString(item.promotionButtonText), 3)
            ], 8, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_unref(store).getters.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('注册或登录后，将为您推荐更多个性化内容。')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              class: "loginBtn btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).commit('status/onLogin', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('登录')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(bury)('ALL_Click_Register'))),
              class: "ml_30",
              to: "/signup"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "signBtn btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('注册')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})